const mutations = {
    setAttributes(state, data) {
        state.attributes = data;
    },
    setAttribute(state,data){
        state.attribute=data;
    },
    resetAttribute(state){
        state.attribute = {
           label : ''
        }
    }
}

export default mutations;